var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAztec(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 159 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    width: 319,
    height: 232,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.42 2l10.892 10.89a4.398 4.398 0 010 6.22L18.399 30.023a4.398 4.398 0 01-6.22 0L1.29 19.13a4.398 4.398 0 010-6.22L12.2 2a4.398 4.398 0 016.22 0zm-3.846 2.762l-.044.041L4.092 15.241a1.1 1.1 0 00-.041 1.511l.041.044 10.423 10.423a1.1 1.1 0 001.511.041l.044-.041L26.508 16.78a1.1 1.1 0 000-1.555L16.085 4.803a1.1 1.1 0 00-1.511-.041zm.925 4.595l6.455 6.455a.275.275 0 010 .39l-6.464 6.463a.275.275 0 01-.389 0L8.646 16.21a.275.275 0 010-.388l6.464-6.464a.275.275 0 01.389 0z",
    fill: "url(#prefix__paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.73 4.5L36 27.547h4.077l1.958-5.264h9.95l1.99 5.264h4.141L49.386 4.5H44.73zm2.248 4.558l3.659 9.63h-7.254l3.595-9.63zm26.32 15.215h-8.891l8.795-10.657v-2.92H59.688v3.273h8.924L59.56 24.658v2.889h13.738v-3.274zm3.852-.963c0 3.434 1.734 4.43 4.944 4.43.995 0 1.958-.097 2.664-.225v-3.242c-.578.064-.93.096-1.573.096-1.38 0-2.246-.16-2.246-1.669v-8.73h3.53v-3.275h-3.53V5.752H77.15v4.943h-2.343v3.274h2.343v9.34zm17.299 4.59c3.37 0 6.034-1.765 7.222-4.718l-3.306-1.252c-.514 1.733-2.023 2.696-3.916 2.696-2.472 0-4.205-1.766-4.494-4.654h11.812v-1.284c0-4.623-2.6-8.314-7.479-8.314-4.686 0-8.025 3.82-8.025 8.763 0 5.2 3.37 8.763 8.186 8.763zm-.193-14.284c2.44 0 3.595 1.605 3.627 3.467h-7.736c.578-2.28 2.119-3.467 4.109-3.467zm13.194 5.521c0-3.434 1.797-5.457 4.429-5.457 2.055 0 3.307 1.38 3.788 3.21l3.242-1.765c-.899-2.697-3.402-4.75-7.03-4.75-4.814 0-8.281 3.562-8.281 8.762 0 5.2 3.467 8.763 8.281 8.763 3.66 0 6.228-2.15 7.094-4.879l-3.306-1.67c-.481 1.863-1.733 3.21-3.788 3.21-2.632 0-4.429-1.99-4.429-5.424z",
    className: "logo-text",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint0_linear",
    x1: 5.51,
    y1: 6.447,
    x2: 25.28,
    y2: 25.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#944AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448FFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAztec);
export default __webpack_public_path__ + "static/media/Aztec.06f2d6b8343fdb290f24f31027c940e8.svg";
export { ForwardRef as ReactComponent };